// /api/moduleTags.js
import api from "@/utils/axios";

// GET all module tags
export const getAllModuleTags = (params = {}) => api.get("/api/module-tags", { params });

// GET module tag by ID
export const getModuleTagById = (id, params = {}) => api.get(`/api/module-tags/${id}`, { params });

// GET all module tags under a specific section
export const getModuleTagsBySection = (sectionId, params = {}) =>
    api.get(`/api/module-tags/module-section/${sectionId}`, { params });

// CREATE a new module tag
export const createModuleTag = (payload) => api.post("/api/module-tags", payload);

// UPDATE a module tag by ID
export const updateModuleTag = (id, payload) => api.put(`/api/module-tags/${id}`, payload);

// DELETE a module tag by ID
export const deleteModuleTag = (id) => api.delete(`/api/module-tags/${id}`);
